import axios from 'axios';
import config from './config';
import Cookies from 'universal-cookie';
const cookies = new Cookies();


const headers = { 'Accept' : 'application/json', 'Content-Type' : 'application/json' }



const api = axios.create({
    baseURL : config.apiBaseUrl[process.env.NODE_ENV],
    headers: headers,    
    timeout : 50000
});

api.interceptors.request.use(
    function(configure) {        
        const myCookies = cookies.get(config.cookiesName);             
        if (myCookies && myCookies.token) {                    
            configure.headers["Authorization"] = 'Token ' + myCookies.token;
        }
        return configure;
    },
    function(error) {
        const {status} = error.response;
        console.log('my status is >>>>', status)        
        return error;        
    },
    error => {
        console.log('error from api is >>>>', error)
    }
);


export default api;